export function formatCompactCount(value: number): string {
  if (value >= 1_000_000) return `${trimZeros(value / 1_000_000)}M`;
  if (value >= 1_000) return `${trimZeros(value / 1_000)}K`;
  return String(value);
}

function trimZeros(value: number): string {
  return Number(value.toFixed(2)).toString();
}
